import { useMemo } from 'react';

import { useRdContext } from '@neo.tax/rd/context';
import { getRdNavSection } from '@neo.tax/rd/utils';
import { SideNavProps, useCurrentCompanyId, useCurrentUserScopeForCurrentCompany } from '@neo.tax/shared';

export const useRdNavSections = (): SideNavProps['sections'] => {
  const companyId = useCurrentCompanyId();
  const { fiscalYearId } = useRdContext();
  const { limitAccessToFinancialData } = useCurrentUserScopeForCurrentCompany();

  return useMemo(
    () =>
      getRdNavSection({
        companyId,
        fiscalYearId,
        isNonFinancialUser: limitAccessToFinancialData,
      }),
    [companyId, fiscalYearId, limitAccessToFinancialData],
  );
};
